"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pdfobject = require("../utils/pdfobject");

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// 是否低版本IE
var isLowVersionOfIE = (0, _spauiUtils.getBrowserVersion)() > 0 && (0, _spauiUtils.getBrowserVersion)() < 10;
/**
 * @class
 */

var DOMComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DOMComponent, _PureComponent);

  function DOMComponent(props) {
    var _this;

    _classCallCheck(this, DOMComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMComponent).call(this, props));
    _this.state = {
      footShow: (0, _spauiUtils.isUndefined)(props.footShow) ? true : props.footShow || false,
      index: (0, _spauiUtils.isUndefined)(props.index) ? 0 : props.index || 0,
      scale: (0, _spauiUtils.isUndefined)(props.scale) ? 0.7 : props.scale || 1,
      deg: (0, _spauiUtils.isUndefined)(props.deg) ? 0 : props.deg || 0
    }; // 对应的id

    _this.id = (0, _spauiUtils.getUniqueId)('spaui-viewer');
    _this.picId = _this.id + '_pic';

    _this.nullList(); // 拖动图片的一些状态信息


    _this.dragImageing = false;
    _this.dragImageTarget = null;
    _this.dragImageStartX = 0;
    _this.dragImageStartY = 0;
    _this.dragImageEndX = 0;
    _this.dragImageEndY = 0;
    _this.dragImageLeft = 0;
    _this.dragImageTop = 0;
    _this.handleToggleShowFoot = _this.handleToggleShowFoot.bind(_assertThisInitialized(_this));
    _this.handleNext = _this.handleNext.bind(_assertThisInitialized(_this));
    _this.handlePrev = _this.handlePrev.bind(_assertThisInitialized(_this));
    _this.handleCurrent = _this.handleCurrent.bind(_assertThisInitialized(_this));
    _this.handleZoomOut = _this.handleZoomOut.bind(_assertThisInitialized(_this));
    _this.handleZoomIn = _this.handleZoomIn.bind(_assertThisInitialized(_this));
    _this.handleDeg = _this.handleDeg.bind(_assertThisInitialized(_this));
    _this.handleImageMouseDown = _this.handleImageMouseDown.bind(_assertThisInitialized(_this));
    _this.handleImageMouseMove = _this.handleImageMouseMove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DOMComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var data = this.props.data;
      var index = this.state.index; // 如果有PDF的化，进行展示

      this.showPDF(); // 设置下缩放比例

      this.setScale(data, index); // 展示当前对应的小图

      this.showCurrentThumbItem();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!(0, _spauiUtils.isUndefined)(nextProps.index)) {
        this.setState({
          index: nextProps.index
        }, function () {
          _this2.showCurrentThumbItem();
        });
      }

      if (!(0, _spauiUtils.isUndefined)(nextProps.scale)) {
        this.setState({
          scale: nextProps.scale
        });
      }

      if (!(0, _spauiUtils.isUndefined)(nextProps.deg)) {
        this.setState({
          deg: nextProps.deg
        });
      }

      if (!(0, _spauiUtils.isUndefined)(nextProps.footShow)) {
        this.setState({
          footShow: nextProps.footShow
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // 如果有PDF的化，进行展示
      this.showPDF();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.thumbListRef = null;
      this.imagesViewerRef = null;
    } // 是否可以拖动图片

  }, {
    key: "canDragImage",
    value: function canDragImage() {
      var dragImage = this.props.dragImage; // 是否可以拖动图片，除了开关还要不能是低版本IE

      return dragImage && !isLowVersionOfIE;
    } // 如果是pdf的话，展示pdf

  }, {
    key: "showPDF",
    value: function showPDF() {
      var _this3 = this;

      var _this$props$data = this.props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data;
      var havePDF = false; // 数据里面是否有PDF

      data.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!havePDF && (0, _pdfobject.isPDF)((0, _index.getItemUrl)(item))) {
          havePDF = true;
        }

        return item;
      }); // 有PDF要加PDF的依赖库

      if (havePDF) {
        (0, _pdfobject.addPDFObject)(function () {
          var index = _this3.state.index;
          var currentData = data[index] || {};
          var currentUrl = (0, _index.getItemUrl)(currentData);

          if (currentData && (0, _pdfobject.isPDF)(currentUrl)) {
            (0, _pdfobject.showPDFObject)(_this3, currentUrl, _this3.picId);
          }
        });
      }
    } // 没指定缩放比例的，计算下默认缩放比例

  }, {
    key: "setScale",
    value: function setScale() {
      var _this4 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props = this.props,
          scale = _this$props.scale,
          usePortal = _this$props.usePortal,
          horizontalGap = _this$props.horizontalGap,
          verticalGap = _this$props.verticalGap,
          thumb = _this$props.thumb,
          prevAndNext = _this$props.prevAndNext,
          _this$props$data2 = _this$props.data,
          propsData = _this$props$data2 === void 0 ? [] : _this$props$data2,
          _this$props$switchdot = _this$props.switchdots,
          switchdots = _this$props$switchdot === void 0 ? false : _this$props$switchdot;
      var image = new Image();
      var imgData = data[index] || null,
          imgUrl = (0, _index.getItemUrl)(imgData),
          imagesViewerRect = {},
          screenWidth = 0,
          screenHeight = 0,
          finalHorizontalGap = 0,
          finalVerticalGap = 0; // 展示图片的父级容器样式

      if (this.imagesViewerRef) {
        try {
          imagesViewerRect = this.imagesViewerRef.getBoundingClientRect();
        } catch (e) {}
      } // 不是浮层展示的话，默认就是组件的宽高


      if (!usePortal && imagesViewerRect.width) {
        screenWidth = imagesViewerRect.width;
        screenHeight = imagesViewerRect.height;
      } else {
        // 如果开启了节点，就用window的实际宽高
        if (switchdots) {
          screenWidth = window.innerWidth;
          screenHeight = window.innerHeight;
        } else {
          screenWidth = window.screen.width;
          screenHeight = window.screen.height;
        }
      }

      if (typeof horizontalGap !== 'undefined') {
        finalHorizontalGap = horizontalGap;
      } else {
        finalHorizontalGap = 250;

        if (!(prevAndNext && propsData && propsData.length > 1)) {
          finalHorizontalGap = 0;
        }
      }

      if (typeof verticalGap !== 'undefined') {
        finalVerticalGap = verticalGap;
      } else {
        finalVerticalGap = 300; // 没有小图

        if (!thumb) {
          finalVerticalGap -= 100;

          if (switchdots) {
            finalVerticalGap -= 40;
          }
        } // 没有头部


        if (!usePortal) {
          finalVerticalGap -= 60;
        }
      } // 如果没有指定scale，计算一下


      if ((0, _spauiUtils.isUndefined)(scale) && imgUrl) {
        image.onload = function () {
          // horizontalGap是头部，按钮这些地方的宽高
          var maxVisibleWidth,
              maxVisibleHeight,
              defaultScale = 0;
          maxVisibleWidth = screenWidth - finalHorizontalGap;
          maxVisibleHeight = screenHeight - finalVerticalGap; // 按照不超过可视容器的最大占比默认展示

          if (image.width > 0 && image.height > 0 && maxVisibleWidth > 0 && maxVisibleHeight > 0) {
            defaultScale = Math.min(maxVisibleHeight / image.height, maxVisibleWidth / image.width);

            if (defaultScale > 1) {
              defaultScale = 1;
            }

            _this4.setState({
              scale: defaultScale
            });
          }
        };

        image.src = imgUrl;
      } // 拖动记录的样式清空


      if (this.dragImageTarget) {
        this.dragImageTarget.style.top = '';
        this.dragImageTarget.style.left = '';
      } // 重新计算要停止拖动


      this.stopDragImage();
    } // 小图滚动到展示的图片位置

  }, {
    key: "showCurrentThumbItem",
    value: function showCurrentThumbItem() {
      var thumbListRect = {},
          thumbItem = null,
          firstThumbItemRect = {},
          secondThumbItemRect = {},
          currentThumbItemRect = {},
          thumbItemSpace = 0,
          currentLeft = 0,
          i = 0,
          len = 0,
          scrollLeft = 0;

      if (this.thumbListRef) {
        thumbListRect = this.thumbListRef.getBoundingClientRect();
        thumbItem = this.thumbListRef.getElementsByTagName('li');
        len = thumbItem.length;

        if (thumbListRect.width > 0 && thumbItem && len > 1) {
          firstThumbItemRect = thumbItem[0].getBoundingClientRect();
          secondThumbItemRect = thumbItem[1].getBoundingClientRect();

          if (firstThumbItemRect.width > 1 && secondThumbItemRect.width > 1) {
            // 获取当前展示的小图的位置
            for (; i < len; i++) {
              if (thumbItem[i] && thumbItem[i].className.indexOf('current') > -1) {
                currentThumbItemRect = thumbItem[i].getBoundingClientRect();
              }
            } // 获取当前距离第一个的距离


            currentLeft = currentThumbItemRect.x - firstThumbItemRect.x; // 每个的间距

            thumbItemSpace = secondThumbItemRect.x - firstThumbItemRect.x; // 滚动距离

            scrollLeft = currentLeft - thumbListRect.width + thumbItemSpace;

            if (scrollLeft < 0) {
              scrollLeft = 0;
            }

            this.thumbListRef.scrollLeft = scrollLeft;
          }
        }
      }
    } // 切换是否展示尾部

  }, {
    key: "handleToggleShowFoot",
    value: function handleToggleShowFoot() {
      this.setState({
        footShow: !this.state.footShow
      });
    } // 下一个图片

  }, {
    key: "handleNext",
    value: function handleNext() {
      var _this5 = this;

      var _this$props$data3 = this.props.data,
          data = _this$props$data3 === void 0 ? [] : _this$props$data3;
      var index = this.state.index;
      var result = 0;

      if (index < data.length - 1) {
        result = index + 1;
      } else {
        result = 0;
      }

      this.setState({
        index: result,
        deg: 0 // 渲染角度重置

      }, function () {
        // 重新设置下缩放比例以及小图的选中态
        _this5.setScale(data, result);

        _this5.showCurrentThumbItem();
      });
    } // 上一个

  }, {
    key: "handlePrev",
    value: function handlePrev() {
      var _this6 = this;

      var data = this.props.data;
      var index = this.state.index;
      var result = 0;

      if (index < 1) {
        result = data.length - 1;
      } else {
        result = index - 1;
      }

      this.setState({
        index: result,
        deg: 0
      }, function () {
        _this6.setScale(data, result);

        _this6.showCurrentThumbItem();
      });
    } // 点击展示第几个

  }, {
    key: "handleCurrent",
    value: function handleCurrent(event, index) {
      var _this7 = this;

      var data = this.props.data;
      this.setState({
        index: index,
        deg: 0
      }, function () {
        _this7.setScale(data, index);
      });
    } // 缩小

  }, {
    key: "handleZoomOut",
    value: function handleZoomOut(event) {
      var _this$props2 = this.props,
          scaleRatio = _this$props2.scaleRatio,
          onScale = _this$props2.onScale,
          propsScale = _this$props2.scale;
      var scale = this.state.scale;
      var result = scale;
      result -= scaleRatio;

      if (result < 0) {
        result = 0;
      }

      if (typeof propsScale === 'undefined') {
        this.setState({
          scale: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onScale)) {
        onScale(event, scale, result);
      }
    } // 放大

  }, {
    key: "handleZoomIn",
    value: function handleZoomIn() {
      var _this$props3 = this.props,
          scaleRatio = _this$props3.scaleRatio,
          maxScale = _this$props3.maxScale,
          onScale = _this$props3.onScale,
          propsScale = _this$props3.scale;
      var scale = this.state.scale;
      var result = scale;
      result += scaleRatio;

      if (result > maxScale) {
        result = maxScale;
      }

      if (typeof propsScale === 'undefined') {
        this.setState({
          scale: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onScale)) {
        onScale(event, scale, result);
      }
    } // 旋转

  }, {
    key: "handleDeg",
    value: function handleDeg(event) {
      var _this$props4 = this.props,
          degRatio = _this$props4.degRatio,
          onDeg = _this$props4.onDeg,
          propsDeg = _this$props4.deg;
      var deg = this.state.deg;
      var result = deg;
      result = result - degRatio;

      if (typeof propsDeg === 'undefined') {
        this.setState({
          deg: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onDeg)) {
        onDeg(event, deg, result);
      }
    } // 开始拖图片

  }, {
    key: "startDragImage",
    value: function startDragImage(currentTarget) {
      if (currentTarget && currentTarget.parentNode) {
        this.dragImageing = true;
        this.dragImageTarget = currentTarget.parentNode;
        this.dragImageTarget.className = 'untransition viewer-pic';
      }
    } // 停止拖图片

  }, {
    key: "stopDragImage",
    value: function stopDragImage() {
      if (this.dragImageTarget) {
        this.dragImageTarget.className = 'viewer-pic';
      }

      this.dragImageing = false;
    } // 拖动按下鼠标

  }, {
    key: "handleImageMouseDown",
    value: function handleImageMouseDown(event) {
      var dragImage = this.canDragImage();
      var originalEvent = event.originalEvent;
      var touches = originalEvent && originalEvent.touches;
      var e = event,
          dragImageTargetLeft = 0,
          dragImageTargetTop = 0,
          dragImageTargetRect = {};

      if (touches) {
        e = touches[0];
      }

      if (dragImage && e.currentTarget) {
        this.startDragImage(e.currentTarget);
        this.dragImageStartX = e.pageX || originalEvent && originalEvent.pageX;
        this.dragImageStartY = e.pageY || originalEvent && originalEvent.pageY;
        dragImageTargetLeft = (0, _spauiUtils.getStyle)(this.dragImageTarget, 'left');
        dragImageTargetTop = (0, _spauiUtils.getStyle)(this.dragImageTarget, 'top');
        dragImageTargetRect = this.dragImageTarget && this.dragImageTarget.getBoundingClientRect();

        if (dragImageTargetLeft === 'auto') {
          dragImageTargetLeft = dragImageTargetRect.left;
        }

        if (dragImageTargetTop === 'auto') {
          dragImageTargetTop = dragImageTargetRect.top;
        }

        this.dragImageLeft = parseInt(dragImageTargetLeft, 10) || 0;
        this.dragImageTop = parseInt(dragImageTargetTop, 10) || 0;
      }
    } // 拖动移动鼠标

  }, {
    key: "handleImageMouseMove",
    value: function handleImageMouseMove(event) {
      var dragImage = this.canDragImage();
      var originalEvent = event.originalEvent;
      var touches = originalEvent && originalEvent.touches;
      var e = event;

      if (dragImage && this.dragImageing) {
        if (touches) {
          e = touches[0];
        }

        this.dragImageEndX = e.pageX || originalEvent && originalEvent.pageX;
        this.dragImageEndY = e.pageY || originalEvent && originalEvent.pageY;
        this.dragImageTarget.style.left = this.dragImageEndX - this.dragImageStartX + this.dragImageLeft + 'px';
        this.dragImageTarget.style.top = this.dragImageEndY - this.dragImageStartY + this.dragImageTop + 'px';

        if ((0, _spauiUtils.getBrowserVersion)() > 8 && (0, _spauiUtils.getBrowserVersion)() < 12) {
          this.dragImageTarget.style.position = 'absolute';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this8 = this;

      var _this$props5 = this.props,
          show = _this$props5.show,
          onClose = _this$props5.onClose,
          _this$props5$data = _this$props5.data,
          data = _this$props5$data === void 0 ? [] : _this$props5$data,
          download = _this$props5.download,
          tool = _this$props5.tool,
          thumb = _this$props5.thumb,
          maxScale = _this$props5.maxScale,
          HeadComponent = _this$props5.HeadComponent,
          PicComponent = _this$props5.PicComponent,
          ToolComponent = _this$props5.ToolComponent,
          BottomComponent = _this$props5.BottomComponent,
          TotalComponent = _this$props5.TotalComponent,
          SwitchDotsComponent = _this$props5.SwitchDotsComponent,
          usePortal = _this$props5.usePortal,
          prevAndNext = _this$props5.prevAndNext,
          total = _this$props5.total,
          fixedScale = _this$props5.fixedScale,
          ExtensionComponent = _this$props5.ExtensionComponent,
          devProps = _this$props5.devProps,
          DisplayComponent = _this$props5.DisplayComponent,
          type = _this$props5.type,
          SmallDisplayComponent = _this$props5.SmallDisplayComponent,
          enabledMaskClose = _this$props5.enabledMaskClose,
          titleBar = _this$props5.titleBar,
          _this$props5$headClas = _this$props5.headClassName,
          headClassName = _this$props5$headClas === void 0 ? '' : _this$props5$headClas,
          _this$props5$headStyl = _this$props5.headStyle,
          headStyle = _this$props5$headStyl === void 0 ? {} : _this$props5$headStyl,
          _this$props5$footStyl = _this$props5.footStyle,
          footStyle = _this$props5$footStyl === void 0 ? {} : _this$props5$footStyl,
          _this$props5$footClas = _this$props5.footClassName,
          footClassName = _this$props5$footClas === void 0 ? '' : _this$props5$footClas,
          _this$props5$contentC = _this$props5.contentClassName,
          contentClassName = _this$props5$contentC === void 0 ? '' : _this$props5$contentC,
          _this$props5$contentS = _this$props5.contentStyle,
          contentStyle = _this$props5$contentS === void 0 ? {} : _this$props5$contentS,
          _this$props5$switchdo = _this$props5.switchdots,
          switchdots = _this$props5$switchdo === void 0 ? false : _this$props5$switchdo,
          _this$props5$classNam = _this$props5.classNameMap,
          classNameMap = _this$props5$classNam === void 0 ? {} : _this$props5$classNam;
      var dragImage = this.canDragImage();
      var _this$state = this.state,
          footShow = _this$state.footShow,
          index = _this$state.index,
          stateScale = _this$state.scale,
          deg = _this$state.deg;
      var globalPropsData = (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(classNameMap.ImagesViewerClassName, (_classNames = {}, _defineProperty(_classNames, classNameMap.ImagesViewerCarouselClassName, !usePortal), _defineProperty(_classNames, classNameMap.ImagesViewerIEClassName, (0, _spauiUtils.getBrowserVersion)() > 8 && (0, _spauiUtils.getBrowserVersion)() < 12), _classNames))
      }, devProps[0], devProps[1]);
      var scale = typeof fixedScale !== 'undefined' ? fixedScale : stateScale;
      var imgData = data[index] || null;
      var contentDOM = null,
          result = null; // 不展示，没有数据或者数据没有内容都不尽兴展示

      if (!show || data.length < 1 || !imgData) {
        return null;
      }

      contentDOM = _react["default"].createElement("div", {
        className: classNameMap.ImagesInnerClassName,
        onMouseMove: this.handleImageMouseMove,
        onMouseUp: function onMouseUp() {
          _this8.stopDragImage();
        }
      }, _react["default"].createElement(HeadComponent, {
        viewerId: this.id,
        info: imgData,
        data: data,
        titleBar: titleBar,
        downloadable: download,
        download: download,
        className: headClassName,
        style: headStyle,
        closeClassName: (0, _classnames["default"])(classNameMap.ImagesCloseClassName, this.props.closeClassName),
        onClose: onClose
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.ImagesBodyClassName, contentClassName, _defineProperty({}, classNameMap.ImagesDragClassName, dragImage)),
        style: contentStyle
      }, enabledMaskClose ? _react["default"].createElement("div", {
        onClick: onClose,
        className: classNameMap.ImagesMaskClassName
      }) : null, _react["default"].createElement(PicComponent, {
        type: type,
        DisplayComponent: DisplayComponent,
        info: imgData,
        data: data,
        scale: scale,
        deg: deg,
        dragImage: dragImage,
        onMouseDown: this.handleImageMouseDown,
        id: this.picId
      }), prevAndNext && data && data.length > 1 ? _react["default"].createElement("a", {
        className: classNameMap.ImagesPreClassName,
        onClick: this.handlePrev
      }, _react["default"].createElement("i", {
        className: "viewer-icon"
      }, _react["default"].createElement("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "20",
        height: "20"
      }), _react["default"].createElement("g", {
        transform: "translate(4.000000, 1.000000)",
        fill: "CurrentColor"
      }, _react["default"].createElement("polygon", {
        transform: "translate(11.500000, 11.500000) scale(-1, 1) rotate(45.000000) translate(-11.500000, -11.500000) ",
        points: "19 4 19 6 19 19 17 19 17 6 4 6 4 4 17 4"
      })))))) : null, prevAndNext && data && data.length > 1 ? _react["default"].createElement("a", {
        className: classNameMap.ImagesNextClassName,
        onClick: this.handleNext
      }, _react["default"].createElement("i", {
        className: "viewer-icon"
      }, _react["default"].createElement("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "20",
        height: "20"
      }), _react["default"].createElement("g", {
        transform: "translate(8.500000, 12.500000) scale(-1, 1) translate(-8.500000, -12.500000) translate(-3.000000, 1.000000)",
        fill: "CurrentColor"
      }, _react["default"].createElement("polygon", {
        transform: "translate(11.500000, 11.500000) scale(-1, 1) rotate(45.000000) translate(-11.500000, -11.500000) ",
        points: "19 4 19 6 19 19 17 19 17 6 4 6 4 4 17 4"
      })))))) : null), switchdots && !thumb ? _react["default"].createElement(SwitchDotsComponent, {
        data: data,
        index: index,
        onCurrent: this.handleCurrent
      }) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.ImagesFootClassName, footClassName, {
          on: footShow
        }),
        style: footStyle
      }, tool ? _react["default"].createElement(ToolComponent, {
        toolable: tool,
        isLowVersionOfIE: isLowVersionOfIE,
        data: data,
        info: imgData,
        onDeg: this.handleDeg,
        scale: scale,
        maxScale: maxScale,
        deg: deg,
        onZoomOut: this.handleZoomOut,
        onZoomIn: this.handleZoomIn,
        fixedScale: fixedScale
      }) : null, thumb ? _react["default"].createElement(BottomComponent, {
        SmallDisplayComponent: SmallDisplayComponent,
        thumbable: thumb,
        totalable: total,
        total: total,
        info: imgData,
        data: data,
        index: index,
        toggleShowFoot: this.handleToggleShowFoot,
        onCurrent: this.handleCurrent,
        onPrev: this.handlePrev,
        onNext: this.handleNext,
        htmlRef: function htmlRef(el) {
          _this8.thumbListRef = el;
        },
        TotalComponent: TotalComponent
      }) : null), typeof ExtensionComponent !== 'undefined' ? _react["default"].createElement(ExtensionComponent, _extends({}, this.props, {
        index: index
      })) : null);

      if (usePortal) {
        result = _react["default"].createElement(_spauiPortal["default"], _extends({}, globalPropsData, {
          ref: function ref(el) {
            _this8.imagesViewerRef = el;
          }
        }), _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classNameMap.ImagesOverlayClassName, this.props.maskClassName),
          ref: function ref(el) {
            _this8.mask = el;
          }
        }), contentDOM);
      } else {
        result = _react["default"].createElement("div", _extends({}, globalPropsData, {
          ref: function ref(el) {
            _this8.imagesViewerRef = el;
          }
        }), contentDOM);
      }

      return result;
    }
  }]);

  return DOMComponent;
}(_react.PureComponent);

var _default = DOMComponent;
exports["default"] = _default;